{
  "loading": "Ladataan…",
  "placeholder": "Valitse…"
}
